// ModalHost — singleton portal target for <Modal> instances.
// Rendered once by RootLayout; every <Modal open> mounts its sheet
// via createPortal into `#modal-host`. See
export function ModalHost() {
  return <div id="modal-host" />;
}
